export default "__VITE_ASSET__D_tUqyD8__"